import { module } from 'modujs';
import { gsap } from 'gsap';
import { textAnimations } from '../utils/text-animations';

export default class extends module {
    constructor(m) {
        super(m);

        this.opened = false;
        this.isLoading = false;
        this.popinContent = this.el.querySelector('.o-popins_content');
        this.pageURL = new URL(window.location);
        
        this.mask = this.el.querySelector('.o-popins_mask');
        this.loading = this.el.querySelector('.o-popins_loading');
        this.marquee = this.el.querySelector('.o-popins_marquee');
        this.marqueeHidden = false;

        this.currentPopin = null;

        this.onClick = this.onClick.bind(this);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        
        // If hash in URL, clean it and open popin
        let hash = new URL(document.URL).hash;
        let type = 'popin';

        if (hash) {
            let cleanHash = null;

            if (hash.includes('#/projet/', 0)) {
                cleanHash = hash.replace('#/projet/', '');
                type = 'projet';
            } else {
                if (hash.charAt(0) == '#') {
                    cleanHash = hash.slice(1);
                }
                if (cleanHash.charAt(0) == '/') {
                    cleanHash = cleanHash.slice(1);
                }
            }

            setTimeout(() => {
                this.call('stop', 'Scroll');
                this.load(cleanHash, type);
            }, 1000);
        }

        this.updateListeners();
    }

    updateListeners() {
        let that = this;
        document.querySelectorAll('[data-popin]').forEach((elt) => {
            elt.removeEventListener('click', that.onClick);
            elt.addEventListener('click', that.onClick);
        });   
    }

    onClick(e) {
        e.preventDefault();
                
        let popinId = e.currentTarget.getAttribute('data-popin');
        let type = 'popin';
        if (popinId.includes('projet/', 0)) {
            type = 'projet';
            popinId = popinId.replace('projet/', '');
        }

        if (this.opened && this.currentPopin) {
            this.currentPopin.classList.remove('-visible');
            this.hideMarquee();
        }

        this.load(popinId, type);
        history.pushState({ urlPath: '#/' + e.currentTarget.getAttribute('data-popin') }, '', this.pageURL.origin + '#/' + e.currentTarget.getAttribute('data-popin'));
    }

    load(popinId, type) {
        let xhrUrl = new URL(ajaxVars.url);
        xhrUrl.searchParams.set('action', 'popins_ajax');
        xhrUrl.searchParams.set('popin_id', popinId);
        xhrUrl.searchParams.set('type', type);

        let that = this;
        that.isLoading = true;

        if (that.opened == false) {
            that.open();
        }

        let xhr = new XMLHttpRequest();
        xhr.open("GET", xhrUrl);
        xhr.send();
        xhr.onload = function(response) {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                let result = xhr.responseText;
                that.isLoading = false;
                that.loading.classList.remove('-visible');

                that.showPopin(result);
            }
        };
    }

    open() {
        this.opened = true;
        this.call('stop', 'Scroll');
        this.el.classList.add('-opened');
        this.mask.classList.add('-visible');
        this.loading.classList.add('-visible');
    }

    close() {
        this.opened = false;
        this.call('start', 'Scroll');
        this.mask.classList.remove('-visible');
        history.pushState(null, '', this.pageURL.origin);
        this.hideAndRemovePopin()

        setTimeout(() => {
            this.el.classList.remove('-opened');
            this.popinContent.innerHTML = '';
        }, 1000);
    }

    showPopin(htmlContent){
        if (!htmlContent) {
            this.close();
            this.el.classList.remove('-opened');
            return;
        }

        this.marquee.classList.add('-visible');
        
        this.popinContent.innerHTML = htmlContent;
        this.currentPopin = this.popinContent.querySelector('.o-popin');
        let marqueeLabel = this.currentPopin.getAttribute('data-marquee');
        this.updateMarqueeLabel(marqueeLabel) ;
        if (this.marqueeHidden) {
            // setTimeout(() => {
                this.showMarquee() ;
            // }, 200);
        }

        setTimeout(() => {
            this.currentPopin.classList.add('-visible');
            this.updateEvents();
            this.updateListeners();
        }, 300);
    }

    hideAndRemovePopin() {
        if (this.currentPopin) {
            this.currentPopin.classList.remove('-visible');
        }
        setTimeout(() => {
            this.marquee.classList.remove('-visible');
        }, 100);
    }

    updateEvents() {
        // Update modules & scroll
        this.call('update', this.el, 'app');
        this.call('addElements', this.popinContent, 'Scroll');
        this.call('update', 'Cursor');
        textAnimations(this.popinContent);
    }


    updateMarquee(value) {
        let tl = gsap.timeline({ onComplete: () => {
            this.updateMarqueeLabel(value);
            setTimeout(() => {
                this.showMarquee();
            }, 50);
        }});

        this.marquee.querySelectorAll('.c-marquee').forEach((elt, index) => {
            tl.to(
                elt.querySelectorAll('.c-marquee_label'),
                { y: '110%', duration: 1.2, ease: 'power4.inOut' },
                0.06*index
            );
        });
    }

    updateMarqueeLabel(value) {
        this.marquee.querySelectorAll('.c-marquee_label').forEach((elt) => {
            elt.innerHTML = value;
        });
    }

    hideMarquee() {
        this.marqueeHidden = true;

        let tl = gsap.timeline();
        this.marquee.querySelectorAll('.c-marquee').forEach((elt, index) => {
            tl.to(
                elt.querySelectorAll('.c-marquee_label'),
                { y: '110%', duration: 0.4, ease: 'power4.out' },
                0
            );
        });
    }
    
    showMarquee() {
        this.marqueeHidden = false;
        let tl = gsap.timeline();
        let marquees = [...this.marquee.querySelectorAll('.c-marquee')].reverse();
        marquees.forEach((elt, index) => {
            tl.to(
                elt.querySelectorAll('.c-marquee_label'),
                { y: '0%', duration: 1, ease: 'power4.out' },
                0.06*index
            );
        });
    }
}
